export default __webpack_public_path__ + "static/media/26.28929af0.png";